import React from 'react';

import TimePicker from '../components/TimePicker';
import NonOptimalStates from '../../hoc/NonOptimalStates';

export const noService = ({ serviceId }) => !serviceId;
export const ServiceError = () => (
  <div>
    Please select service first
  </div>
);

export const noBarber = ({ barberId }) => !barberId;
export const BarberError = () => (
  <div>
    Please select a professional
  </div>
);

export const noTimes = ({ noTimesAvailable }) => noTimesAvailable;
export const TimesError = () => (
  <div>
    There are no available time for selected day.
  </div>
);

const TimePickerContainer = NonOptimalStates([
  { when: noService, render: ServiceError },
  { when: noBarber, render: BarberError },
  { when: noTimes, render: TimesError },
])(TimePicker);

export default TimePickerContainer;



// WEBPACK FOOTER //
// ./src/app/times/containers/TimePicker.jsx